export default __webpack_public_path__ + "static/topActive.png";